import { css } from '@emotion/css';
import React from 'react';
import { Loading } from 'src/components/shared/Loading';
import { throttle } from 'src/lib/utils';

type PointGetButtonProps = {
  onClick: () => void;
  loading?: boolean;
};

const bgColor1 = '#3fd144';
const bgColor2 = '#3fc142';

export const PointGetButton: React.FC<PointGetButtonProps> = ({ onClick, loading, children }) => {
  return (
    <button
      className={css`
        min-width: 240px;
        min-height: 56px;
        border-radius: 28px;
        border: 5px solid #83e68a;
        color: white;
        font-size: 18px;
        background: repeating-linear-gradient(
          -50deg,
          ${bgColor1},
          ${bgColor1} 12px,
          ${bgColor2} 12px,
          ${bgColor2} 24px
        );
        &:active {
          transform: scale(0.98, 0.95);
        }
        padding: 2px 20px;
        @media screen and (min-width: 330px) {
          min-height: 64px;
          border-radius: 32px;
          font-size: 20px;
        }
      `}
      disabled={loading}
      onClick={onClick && throttle(onClick, 1000, 200)}
    >
      {loading ? <Loading color="white" size={45} /> : children}
    </button>
  );
};
